import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss'; // Reusing the same SCSS for consistency
import { ReactComponent as Improve_lifting_techniqueIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_lifting_technique.svg';
import { ReactComponent as Improve_range_of_motionIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_range_of_motion.svg';
import { ReactComponent as Reduce_stiffnessIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/reduce_stiffness.svg';
import { ReactComponent as Support_recoveryIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/support_recovery.svg';
import { ReactComponent as Move_betterIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/move_better.svg';

interface MobilityStep2Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  move_better: <Move_betterIcon />,
  improve_lifting_technique: <Improve_lifting_techniqueIcon />,
  reduce_stiffness: <Reduce_stiffnessIcon />,
  support_recovery: <Support_recoveryIcon />,
  improve_range_of_motion: <Improve_range_of_motionIcon />,
};

// What is the purpose of this program?
export const MobilityStep2: FC<MobilityStep2Props> = ({ value, onNext }) => {
  const [selectedPurpose, setSelectedPurpose] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const groupData = programMasterData?.trainingGoalPreferences?.groups?.find(
    (g: any) => g.goalId === 'mobility',
  );

  const purposes = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>

      <div className="goal-buttons">
        {purposes.map((purpose: any) => (
          <button
            key={purpose.id}
            className={`goal-btn ${selectedPurpose === purpose.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedPurpose(purpose.slug);
              if (onNext) onNext(purpose.slug);
            }}
          >
            <div className="goal-icon">{iconMap[purpose.id]}</div>
            <span className="goal-label">{purpose.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
